export enum ULinkIdEnum {
  AppPetWXSS = 'usrupo2qbu7kbsc',
  AppPetUserSitterWXSS = 'usr1h2ub5mvib3f8',
}
